import { CheckoutEventError } from '../../models/checkout/checkout-event-error.interface';

export const mockCheckoutEventError: CheckoutEventError = {
  transactionId: '123456', // optional
  status: 'error',
  eventDescription: 'Checkout failed',

  ...new CustomEvent('checkout-event-success', {
    detail: {
      transactionId: '123456', // optional
      status: 'error',
      eventDescription: 'Checkout failed',
    },
  }),
};
